<template>
  <section>
    <div
      :style="`background-image: url('${require('@/assets/images/login-bg.png')}');`"
      class="bg-img1"
    ></div>

    <div class="login-form-container is-shadow">
      <div class="card">
        <div class="card-image">
          <b-image
            :src="require('@/assets/images/up-skool-logo.png')"
            alt="Placeholder image"
          ></b-image>
        </div>
        <div class="card-content pt-0 px-6">
          <div class="columns">
            <div class="column is-half">
              <h4 class="h4">General Information</h4>

              <b-field label="Parent's name *">
                <b-input v-model="signupDetails.name" type="text"></b-input>
              </b-field>

              <b-field label="Child's name *">
                <div v-for="(kid,kid_i) in signupDetails.kids" :key="kid_i" style="display:flex;">
                  <b-input type="text" v-model="signupDetails.kids[kid_i]" style="flex-grow:1" expanded></b-input>
                  <b-button id="basic-addon2" class="is-radiusless" type="is-success" @click="addRow()">+</b-button>
                  <b-button id="basic-addon2" class="is-radiusless" type="is-danger" @click="deleteRow(kid_i)">x</b-button>
                </div>
              </b-field>

              <!-- <div class="columns">
                <div class="column">
                  <b-field label="Subscription start date">
                    <b-input type="date" id="subs_start_date"></b-input>
                  </b-field>
                </div>
              </div> -->
              <div class="columns">
                <div class="column">
                  <b-field label="Email address *">
                    <b-input type="email" v-model="signupDetails.email" id="email"></b-input>
                  </b-field>
                </div>
              </div>
              <div class="columns">
                <div class="column">
                  <b-field label="Confirm email address *">
                    <b-input type="email" v-model="signupDetails.email1" id="confirm_email"></b-input>
                  </b-field>
                </div>
              </div>
              <div class="columns">
                <div class="column">
                  <b-field label="Mobile *">
                    <b-input type="text" v-model="signupDetails.mobile" maxlength="10" id="mobile"></b-input>
                  </b-field>
                </div>
              </div>
              <div class="columns">
                <div class="column">
                  <b-field label="Password *">
                    <b-input type="password" v-model="signupDetails.password" id="password"></b-input>
                  </b-field>
                </div>
              </div>
              <div class="columns">
                <div class="column">
                  <b-field label="Confirm password *">
                    <b-input type="password" v-model="signupDetails.password1" id="password_confirm"></b-input>
                  </b-field>
                </div>
              </div>

              <hr />

              <h4 class="h4">Billing Information</h4>

              <b-field label="Company ">
                <b-input type="text" v-model="signupDetails.company" id="company"></b-input>
              </b-field>

              <b-field label="Address *">
                <b-input v-model="signupDetails.billing_address" id="address"></b-input>
              </b-field>

              <div class="columns">
                <div class="column is-one-third">
                  <b-field label="City *">
                    <b-input type="text" v-model="signupDetails.city" id="city"></b-input>
                  </b-field>
                </div>
                <div class="column is-one-third">
                  <b-field label="State *">
                    <b-select placeholder="Select a state" v-model="signupDetails.state" id="state">
                      <option v-for="val in myJson" :key="val">{{val}}</option>
                    </b-select>
                  </b-field>
                </div>
                <div class="column">
                  <b-field label="Pincode *">
                    <b-input type="text" v-model="signupDetails.zip" maxlength="6" id="zip"></b-input>
                  </b-field>
                </div>
              </div>
            </div>

            <div class="column is-half">
              <div class="cart-box has-background-link-light">
                <div class="columns my-2">
                  <div class="column">
                    <h5 class="has-text-link mb-2 h5">No. of children:</h5>
                  </div>
                  <div class="column">
                    <h5 class="has-text-right has-text-link mb-2 h5">{{signupDetails.kids.length}}</h5>
                  </div>
                </div>

                <div
                  class="mb-2 has-background-white"
                  style="padding: 10px; border: 1px solid rgb(78, 73, 161)"
                >
                  <div class="columns mb-0">
                    <div class="column">
                      <h5 class="text-center mb-0 has-text-link h5">Amount Details</h5>
                    </div>
                  </div>
                  <div class="columns my-1">
                    <div class="column">
                      <p class="mb-0 has-text-link">Price per child:</p>
                    </div>
                    <div class="column">
                      <p class="mb-0 has-text-right has-text-link">₹ 500</p>
                    </div>
                  </div>
                  <div class="columns my-1" v-if="signupDetails.kids.length>1">
                    <div class="column">
                      <p class="mb-0 has-text-link">Price per additional child:</p>
                    </div>
                    <div class="column">
                      <p class="mb-0 has-text-right has-text-link">₹ 300</p>
                    </div>
                  </div>
                  <div class="columns my-1">
                    <div class="column">
                      <p class="mb-0 has-text-link">Duration:</p>
                    </div>
                    <div class="column">
                      <b-select class="mb-0 has-text-right has-text-link" placeholder="Duration" v-model="duration">
                        <option value=1 selected>One month</option>
                        <option value=6 >Semi annual</option>
                        <option value=12 >Annual</option>
                      </b-select>
                    </div>
                  </div>
                  <div class="columns my-2">
                    <div class="column">
                      <p class="mb-0 has-text-link">Gross amount:</p>
                    </div>
                    <div class="column">
                      <p class="mb-0 has-text-right has-text-link">₹ {{grossAmount}}</p>
                    </div>
                  </div>
                </div>

                <!-- <div class="columns my-2">
                  <div class="column">
                    <p class="mb-0 has-text-link">Total amount:</p>
                  </div>
                  <div class="column">
                    <p class="mb-0 has-text-right has-text-link">{{grossAmount}}</p>
                  </div>
                </div> -->

                <!-- <div class="columns my-2">
                  <div class="column pr-0">
                    <b-input
                      type="text"
                      placeholder="Add coupon code"
                    ></b-input>
                  </div>
                  <div class="column pl-0">
                    <b-button type="button" class="is-primary"
                      >Validate</b-button
                    >
                  </div>
                </div> -->

                <div class="columns my-2">
                  <div class="column">
                    <h5 class="has-text-link h5">Net amount:</h5>
                  </div>
                  <div class="column">
                    <h5 class="has-text-right has-text-link h5">₹ {{grossAmount}}</h5>
                  </div>
                </div>

                <div>
                  <b-field>
                    <b-checkbox
                      id="defaultCheck1"
                      class="has-text-link"
                      style="margin-top: -2px"
                      v-model="agree"
                    >
                      <b
                        >By submitting this form I agree to be contacted by you
                        through phone, text or email</b
                      >
                    </b-checkbox>
                  </b-field>
                  <b-field>
                    <b-checkbox
                      id="defaultCheck1"
                      class="has-text-link"
                      style="margin-top: -2px"
                      v-model="term"
                    >
                      <b
                        >I agree to Mindverse, LLC
                        <a
                          target="_blank"
                          href="https://up-skool.com/terms-of-use"
                          class="text-white"
                          >Terms of Service</a
                        >
                        and
                        <a
                          target="_blank"
                          href="https://up-skool.com/privacy-policy"
                          class="text-white"
                          >Privacy Policy</a
                        ></b
                      >
                    </b-checkbox>
                  </b-field>
                  <div class="columns my-2">
                    <div class="column is-full text-center">
                      <b-button
                        type="button"
                        class="has-text-primary has-background-white p-auto"
                        @click="signup()"
                        :disabled="disabled"
                        >Proceed</b-button
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import { mapActions } from "vuex";
  import json from '@/assets/data/indian_states.json'
  export default {
  name: "SignUp",
  data(){
    return{
       term:false,
       agree:false,
       duration:1,
       myJson:json,
       signupDetails:{
        name:"",
        kids:[""],
        email:"",
        email1:"",
        password:"",
        password1:"",
        mobile:"",
        company:"",
        billing_address:"",
        city:"",
        state:"",
        zip:"",
       },
    }
  },
  computed:{
    grossAmount(){
      let gross = 0
      if(this.signupDetails.kids.length == 1){
        gross = this.duration * 500;
      }
      else
      {
        gross = this.duration * 500 + (this.signupDetails.kids.length-1) * this.duration * 300;
      }
      return gross
    },
    disabled(){
      if(this.term && this.agree){
        return false;
      }
      else{
        return true;
      }
    },
  },
  methods: {
    ...mapActions([
      "signupUser",
    ]),
    addRow(){
      this.signupDetails.kids.push("");
    },
    deleteRow(kid_i){
      this.signupDetails.kids.splice(kid_i, 1)
    },
    signup(){
      if(this.signupDetails.email==this.signupDetails.email1 && this.signupDetails.password == this.signupDetails.password1){
        this.isLoading = true
        this.signupUser(
            this.signupDetails
        ).then((response) => {
            this.isLoading = false
            this.$buefy.toast.open({
                message: response.data.msg,
                type: 'is-success'
            })
            this.$router.push({
                name : 'login'
            })
        }).catch(err => {
            this.isLoading = false
            console.log(err);
            this.$buefy.toast.open({
                message: err.response.data,
                type: 'is-danger'
            })
        })
      }
      else{
        this.isLoading = false
        this.$buefy.toast.open({
                message: "Both email and password doesn't match",
                type: 'is-danger'
            })
      }
      
    }
  }
};
</script>

<style>
.cart-box {
  border: 2px solid #4e49a1;
  color: #fff;
  padding: 1rem 2rem;
}

.text-center {
  text-align: center !important;
}

.h5 {
  font-size: 18px;
  font-weight: 700;
}

.h4 {
  font-size: 24px;
  font-weight: 700;
}

.login-form-container {
  position: absolute;
  width: 130%;
  align-self: center;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  justify-content: center;
  align-items: center;
}

.login-form-container .card-image {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 225px;
}

.login-form-container .card-image img {
  width: 200px;
  margin: 0;
}

.login-form-container .card {
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.267);
  width: 60%;
}

/* media query responsive */

@media screen and (max-width: 1024px) {
  .login-form-container .card {
    width: 70%;
  }
}

@media screen and (max-width: 768px) {
  .login-form-container .card {
    width: 80%;
  }

  .login-form-container .card-image {
    height: 150px;
  }

  .login-form-container .card-image img {
    width: 200px;
  }
}
.bg-img1 {
  position: fixed;
  width: 100%;
  min-height: 100vh;
  background-size: 100% 100%;
  background-position: center bottom;
  background-repeat: no-repeat;
  background-color: #999;
}
</style>